import React from 'react';

import styles from './index.scss';
import classNames from 'classnames';

const hardcodedResults = [
    'Powerchute',
    'UPS',
    'PDU',
    'Replacement Battery',
    'Recycle',
    'Product Registration',
    'BR1500MS',
    'AP9631',
    'SRT5KRMXLT',
    'AR3100',
    'BR1500G',
    'FA379541',
];

const popularResultClasses = classNames({
    [styles.popularResult]: true,
    'analytics-popular-result': true,
});

const PopularSearches = () => (
    <div className={styles.popularSearches}>
        <div className={styles.popularSearches__title}>Popular searches</div>
        <ul className={styles.popularSearches__list}>
            {hardcodedResults.map((result, index) => (
                <li
                    className={popularResultClasses}
                    key={`${index}-${result}`}
                    data-item-name={result}
                >
                    <a
                        className={styles.popularResult__link}
                        href={`/shop/us/en/search?Nty=1&Dy=1&expandGlobalFacet=&Ntt=${result}`}
                    >
                        {result}
                    </a>
                </li>
            ))}
        </ul>
    </div>
);

export default PopularSearches;
